import * as React from 'react';

import { isInternalLink } from 'components/lexemes/utils/utils';
import { listenForCookieConsent, onUsePrivacyManagerHandler } from 'lib/cookie-consent';
import { useRouter } from 'next/router';

type PageContainerProps = React.PropsWithChildren;

function PageContainer({ children }: PageContainerProps) {
  const router = useRouter();
  const hashRef = React.useRef<string>('');

  React.useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      return listenForCookieConsent();
    } else {
      return;
    }
  }, []);
  React.useEffect(onUsePrivacyManagerHandler, []);

  React.useEffect(() => {
    const handleNextHashChange = () => {
      const hash = window.location.hash;
      hashRef.current = hash;
    };
    // detect window hash changes that next is not aware of,
    // this allows to detect link clicks with fragments,
    // while ignoring back navigations fragment changes
    const handleWindowHashChange = () => {
      const hash = window.location.hash;
      if (isInternalLink(hash) && hashRef.current !== hash) {
        router.push(hash);
      }
    };

    router.events.on('hashChangeStart', handleNextHashChange);
    window.addEventListener('hashchange', handleWindowHashChange);

    return () => {
      router.events.off('hashChangeStart', handleNextHashChange);
      window.removeEventListener('hashchange', handleWindowHashChange);
    };
  }, [router]);

  return children;
}

export { PageContainer };
